import axiosReq from "../utils/axiosReq";

/*
 *电子电气零部件
 */
const baseApi =
    import.meta.env.VITE_APP_NODE_ENV == 'development' ? "/OpenApiPrefix/api" : '/api';

// const baseApi = "/OpenApiPrefix/api";
const elecCommonPrefix = `${baseApi}/board/v1/premaintain/premaintaincommon`;
const elecPrefix = `${baseApi}/board/v1/premaintain/premaintainfault`;
const faultPrefix = `${baseApi}/board/v1/premaintain/premaintainfault`
const modelPrefix = `${baseApi}/board/v1/premaintain/premaintainmodel` //模型管理前缀
const vehiclePrefix = `${baseApi}/board/v1/premaintain/premaintainrepair` //车辆管理前缀
const twinPrefix = `${baseApi}/board/v1/premaintain/twinmodel` //诊断孪生
const tboxPrefix = `${baseApi}/board/v1/premaintain/tbox` //诊断孪生
const travelPrefix = `${baseApi}/board/v1/travelrecorder` //行驶记录仪
//
export const selectDatabaseDicModelHttpUrl = `${elecCommonPrefix}/selectDatabaseDicModel` //查询数据库名、表名、字段的三级查询
export const selectTruckTypeModelHttpUrl = `${elecCommonPrefix}/selectTruckTypeModel` //查询车型接口
export const selectFaultDicModelHttpUrl = `${elecCommonPrefix}/selectFaultDicModel` //字典表（查询故障字典表数据）
export const selectCabPlatformModelHttpUrl = `${elecCommonPrefix}/selectCabPlatformModel` //平台列表
export const selectTruckPartModelHttpUrl = `${elecCommonPrefix}/selectTruckPartModel` //查询故障项
export const selectVehiclePartsModelHttpUrl = `${elecCommonPrefix}/selectVehiclePartsModel` //查询部件模块（电子电气系统、后处理）(废弃)
export const selectFaultRelateModelHttpUrl = `${elecCommonPrefix}/selectFaultRelateModel` //查询关联故障列表
export const selectHorsepowerModelHttpUrl = `${elecCommonPrefix}/selectHorsepowerModel` //马力列表
export const selectEngineBrandHttpUrl = `${elecCommonPrefix}/selectEngineBrand` //发动机品牌列表
export const selectFaultNameTiersModelHttpUrl = `${elecCommonPrefix}/selectFaultNameTiersModel` //故障三级列表
//
export const selectDataListHttpUrl = `${elecPrefix}/selectDataList` //电子电气时间查询0F30数据接口
export const selectFaultDataListHttpUrl = `${elecPrefix}/selectFaultDataList` //按车辆故障接口查询接口
export const selectFaultItemListHttpUrl = `${elecPrefix}/selectFaultItemList` //按故障项接口查询
export const selectFaultDataCurveListHttpUrl = `${elecPrefix}/selectFaultDataCurve` //按车辆故障查询电流信息接口
//故障管理
export const selectFaultManageListModelListHttpUrl = `${faultPrefix}/selectFaultManageListModel` //故障管理列表查询
export const selectModelQueryListListHttpUrl = `${faultPrefix}/selectModelQueryList` //模型列表查询
//模型管理
export const selectPreMaintainListModelHttpUrl = `${modelPrefix}/selectPreMaintainListModel` //模型列表查询
export const selectPreMaintainTrainFaultListHttpUrl = `${modelPrefix}/selectPreMaintainTrainFaultList` //训练列表=》故障列表查询
export const selectPreMaintainExecuteFaultListHttpUrl = `${modelPrefix}/selectPreMaintainExecuteFaultList` //实施列表
export const selectPreMaintainTruckRelateModelListHttpUrl = `${modelPrefix}/selectPreMaintainTruckRelateModelList` //车辆列表查询
export const selectPreMaintainTrainListHttpUrl = `${modelPrefix}/selectPreMaintainTrainList` //训练模型列表
export const getElecDetailInfoHttpUrl = `${twinPrefix}/getElecDetailInfo` //电流详情
//车辆管理
export const selectPreMaintainTruckModelListHttpUrl = `${vehiclePrefix}/selectPreMaintainTruckModelList` //车辆列表查询
export const selectTruckRelateFaultModelListHttpUrl = `${vehiclePrefix}/selectTruckRelateFaultModelList` //车辆模型关联列表
//诊断孪生
//tbox
export const selectTboxInfoRespHttpUrl = `${tboxPrefix}/selectTboxInfoResp` //tbox列表
export const canDataListHttpUrl = `${tboxPrefix}/canDataList`
//行驶记录仪
export const selectSupplierListHttpUrl = `${travelPrefix}/selectSupplierList`//查询供应商信息
export const selectVinListHttpUrl = `${travelPrefix}/selectVinList`//查询车架号信息
export const selectTravelRecorderBasicInfoHttpUrl = `${travelPrefix}/selectTravelRecorderBasicInfo`//查询行驶记录仪分页信息
export const tboxOfflineListHttpUrl = `${baseApi}/board/v1/mgmt/truck-offline/list`
export const tboxManageListHttpUrl = `${baseApi}/board/v1/mgmt/tbox/list` //tbox管理-列表
export const tboxModelListHttpUrl = `${baseApi}/board/v1/mgmt/dictionary/byName/TBOX_TYPE` //tbox管理-类型列表
export const tboxProtocalListHttpUrl = `${baseApi}/board/v1/mgmt/dictionary/byName/TBOX_PROTOCAL` //tbox管理-协议列表   
export const tboxModelTypeListHttpUrl = `${baseApi}/board/v1/mgmt/tbox-model/tbox-model-type` //tbox管理->添加->Tbox型号 tboxType: TBOX_TYPE_1
export const modelListHttpUrl = `${baseApi}/board/v1/mgmt/tbox-model/list` //tbox型号管理列表   
export const glonassManagerHttpUrl = `${baseApi}/board/v1/mgmt/glonass/list` //glonass管理列表   
export const adasisListHttpUrl=`${baseApi}/board/v1/adasis/getList` //adasis列表
export const alarmRecordHttpUrl = `${baseApi}/board/v1/battery-management/mgmt/alarm-log`//蓄电池告警记录列表
export const currentAlarmListHttpUrl = `${baseApi}/board/v1/battery-management/mgmt/current-alarm`//蓄电池当前告警列表
export const highDensityCollectionListHttpUrl=`${baseApi}/board/v1/mgmt/high/collection/baseData`//高密采集配置 ，获取密集采集配置数据项
// export const selectedHighDensityCollectionListHttpUrl=`${baseApi}/board/v1/mgmt/high/collection`//高密采集配置 ，获取密集采集配置数据项
export const operationLogListHttpUrl=`${baseApi}/board/v1/mgmt/operating/log`//获取操作日志
export const batteryOverPressureListHttpUrl=`${baseApi}/board/v1/battery-management/mgmt/vehicleBatteryOverpressure` //蓄电池管理-统计分析-超压时长top5
export const batteryUnderPressureListHttpUrl=`${baseApi}/board/v1/battery-management/mgmt/vehicleBatteryUnderpressure` //蓄电池管理-统计分析-欠压时长top5
export const alarmStatisticsTimesListHttpUrl=`${baseApi}/board/v1/battery-management/mgmt/alarm-statistics-times`//零部件孪生 =>蓄电池=》 统计分析-告警次数
export const alarmStatisticsCurveDataListHttpUrl=`${baseApi}/newc-platform/v1/portal/web/alarm-statistics-curve-data`//零部件孪生 =>蓄电池=》 统计分析-曲线数据:列表
export const vehicleBatteryCurveStatisticsListHttpUrl=`${baseApi}/board/v1/battery-management/mgmt/vehicleBatteryCurveStatistics`//零部件孪生 =>蓄电池=》 统计分析-曲线数据:图表

/**
 * elecCommonPrefix
 */
//查询数据项接口
export function selectDictionaryTypeHttpReq(dataType = 1) {
    return axiosReq({
        url: `${elecCommonPrefix}/selectDictionaryType?dataType=${dataType}`,
        method: 'get',
    });
}

//查询车型接口
export function selectTruckTypeModelHttpReq() {
    // {{sany-truck-master-board}}/v1/premaintain/premaintaincommon/selectTruckTypeModel
    return axiosReq({
        url: `${elecCommonPrefix}/selectTruckTypeModel`,
        method: 'get',
    });
}
//查询故障项接口
export function selectTruckPartModelHttpReq(partId = 1) {
    // {{sany-truck-master-board}}/v1/premaintain/premaintaincommon/selectTruckPartModel
    return axiosReq({
        url: `${elecCommonPrefix}/selectTruckPartModel?partId=${partId}`,
        method: 'get',
    });
}
//查询故障字典表数据
export function selectFaultDicModelHttpReq(dicType) {
    return axiosReq({
        url: `${elecCommonPrefix}/selectFaultDicModel?dicType=${dicType}`,
        method: 'get',
    });
}
//
//查询马力列表
export function selectHorsepowerModelHttpReq() {
    return axiosReq({
        url: `${elecCommonPrefix}/selectHorsepowerModel`,
        method: 'get',
    });
}
//查询平台数据列表
export function selectCabPlatformModelHttpReq() {
    return axiosReq({
        url: `${elecCommonPrefix}/selectCabPlatformModel`,
        method: 'get',
    });
}

//查询发动机列表
export function selectEngineBrandHttpReq() {
    return axiosReq({
        url: `${elecCommonPrefix}/selectEngineBrand`,
        method: 'get',
    });
}

//查询关联故障列表
export function selectFaultRelateModelHttpReq(partId) {
    return axiosReq({
        url: `${elecCommonPrefix}/selectFaultRelateModel?partId=${partId}`,
        method: 'get',
    });
}
//查询数据库名、表名、字段的三级查询
export function selectDatabaseDicModelHttpReq(pid) {
    return axiosReq({
        url: `${elecCommonPrefix}/selectDatabaseDicModel?pid=${pid}`,
        method: 'get',
    });
}
//查询部件模块（电子电气系统、后处理）(废弃)
export function selectVehiclePartsModelHttpReq(partName = "") {
    // console.log("---partName---", partName, "---")
    if (partName) {
        return axiosReq({
            url: `${elecCommonPrefix}/selectVehiclePartsModel?partName=${partName}`,
            method: 'get',
        });
    }
    partName = ""
    return axiosReq({
        url: `${elecCommonPrefix}/selectVehiclePartsModel?partName=${partName}`,
        method: 'get',
    });
}

export function selectFaultNameTierModelHttpReq(dataType) {
    // selectFaultNameTierModel
    return axiosReq({
        url: `${elecCommonPrefix}/selectFaultNameTierModel?dataType=${dataType}`,
        method: 'get'
        // method: 'post'
    });
}
//故障三级列表
export function selectFaultNameTiersModelHttpReq(dataType) {
    return axiosReq({
        url: `${elecCommonPrefix}/selectFaultNameTiersModel?dataType=${dataType}`,
        method: 'get'
        // method: 'post'
    });
}

/**
 * 故障管理
 */
//  故障管理列表新增
export function addFaultManageHttpReq(data) {
    return axiosReq({
        url: `${faultPrefix}/addFaultManage`,
        method: 'post',
        data,
    });
}
//故障管理列表更新
export function updateFaultManageHttpReq(data) {
    return axiosReq({
        url: `${faultPrefix}/updateFaultManage`,
        method: 'post',
        data,
    });
}

//故障管理列表删除
export function deleteFaultManageHttpReq(id) {
    return axiosReq({
        url: `${faultPrefix}/deleteFaultManage?id=${id}`,
        method: 'get',
    });
}

/**
 * 模型管理
 */
//添加模型
export function addPreMaintainListModelHttpReq(data) {

    return axiosReq({
        url: `${modelPrefix}/addPreMaintainListModelOne`,
        method: 'post',
        data,
    });
}
//更新模型信息
export function updatePreMaintainListModelHttpReq(data) {

    return axiosReq({
        url: `${modelPrefix}/updatePreMaintainListModelOne`,
        method: 'post',
        data,
    });
}
//查询单个模型信息
export function selectPreMaintainModelOneHttpReq(modelId, batchCode) {
    return axiosReq({
        url: `${modelPrefix}/selectPreMaintainModelOne?modelId=${modelId}&batchCode=${batchCode}`,
        method: 'get',
    });
}

//删除关联、deletePreMaintainTruckRelateModel
export function deletePreMaintainTruckRelateModelHttpReq(data) {
    return axiosReq({
        url: `${modelPrefix}/deletePreMaintainTruckRelateModel`,
        method: 'get',
        data,
        isParams: true
    });
}

//训练列表查询
export function selectPreMaintainTrainListHttpReq(modelId) {
    return axiosReq({
        url: `${modelPrefix}/selectPreMaintainTrainList?modelId=${modelId}`,
        method: 'get',
    });
}

//实施全关联开闭接口   
export function updateExecuteOpenOrCloseHttpReq(data) {
    return axiosReq({
        url: `${modelPrefix}/updateExecuteOpenOrClose`,
        method: 'get',
        data,
        isParams: true,
    });
}

//训练全关联开闭接口
export function updateTrainOpenOrCloseHttpReq(data) {
    return axiosReq({
        url: `${modelPrefix}/updateTrainOpenOrClose`,
        method: 'get',
        data,
        isParams: true,
    });
}
//查询模型是否全关联车辆数据
// @RequestParam("modelId")long modelId,
//@RequestParam("batchCode"
export function selectModelRelateAllTruckModelHttpReq(data) {
    return axiosReq({
        url: `${modelPrefix}/selectModelRelateAllTruckModel`,
        method: 'get',
        data,
        isParams: true,
    });
}
// 训练-实施关联接口
export function updateFaultModelRelVinParamModelHttpReq(data) {
    return axiosReq({
        url: `${modelPrefix}/updateFaultModelRelVinParamModel`,
        method: 'post',
        data
    });
}

//训练
export function excuteTrainHttpReq(modelId, batchCode) {
    return axiosReq({
        url: `${modelPrefix}/carryOutTrainButton?modelId=${modelId}&batchCode=${batchCode}`,
        method: 'get'
    });
}
//实施
export function excuteRunHttpReq(modelId, batchCode) {
    return axiosReq({
        url: `${modelPrefix}/carryOutExecuteButton?modelId=${modelId}&batchCode=${batchCode}`,
        method: 'get'
    });
}

/**
 * 车辆管理
 */
//车辆模型关联列表
export function selectTruckRelateFaultModelListHttpReq(data) {
    return axiosReq({
        url: `${vehiclePrefix}/selectTruckRelateFaultModelList`,
        method: 'get',
        data,
        isParams: true,
    });
}
//删除车辆关联模型
export function deleteTruckRelateFaultModelHttpReq(data) {
    return axiosReq({
        url: `${vehiclePrefix}/deleteTruckRelateFaultModel`,
        method: 'get',
        data,
        isParams: true,
    });
}
//新增车辆关联模型
export function addTruckRelateFaultModelHttpReq(data) {
    return axiosReq({
        url: `${vehiclePrefix}/addTruckRelateFaultModel`,
        method: 'post',
        data
    });
}
//查询公共故障模型、关联故障
export function selectCommonFaultModelHttpReq(data) {
    //console.log("查询公共故障模型---data:", data)
    return axiosReq({
        url: `${vehiclePrefix}/selectCommonFaultModel?name=${data.name}`,
        method: 'get'
    });
}
//
//诊断孪生,获取静态数据条目
export function getFuseBasicModelInfoHttpReq() {
    // getFuseBasicModelInfo
    return axiosReq({
        url: `${twinPrefix}/getFuseBasicModelInfo`,
        method: 'post',
        data: {},
        // isParams: true,
    });
}
//诊断孪生历史数据查询(获取模型保险电流信息)
export function getFuseElcModelInfoHttpReq(data) {

    return axiosReq({
        url: `${twinPrefix}/getFuseElcModelInfo`,
        method: 'post',
        data,
        // isParams: true,
    });
}
//诊断孪生历史数据查询(仅获取电流数据)
export function getDataHistRespHttpReq(data) {
    return axiosReq({
        url: `${twinPrefix}/getDataHistResp`,
        method: 'post',
        data,
        // isParams: true,
    });
}

//诊断孪生获取电流详情
export function getElecDetailInfoHttpReq(data) {

    return axiosReq({
        url: `${twinPrefix}/getElecDetailInfo`,
        method: 'post',
        data,
    });
}
//诊断孪生-获取车辆在线状态
export function getTboxStatusHttpReq(vinList) {
    let data = vinList
    return axiosReq({
        url: `${twinPrefix}/getTboxStatus`,
        method: 'post',
        data,
    });
}
//诊断孪生，获取实时数据 getRealTimeDetailInfo
export function getRealTimeDetailInfoHttpReq(vin) {
    return axiosReq({
        url: `${twinPrefix}/getRealTimeDetailInfo?vin=${vin}`,
        method: 'get',
    });
}

//车辆心跳提醒
export function sendHeartBitHttpReq(vin) {
    return axiosReq({
        url: `${twinPrefix}/addRtVin?vin=${vin}`,
        method: 'get',
    });
}
//车辆断开心跳提醒
export function cancelHeartBitHttpReq(vin) {
    return axiosReq({
        url: `${twinPrefix}/deleteRtVin?vin=${vin}`,
        method: 'get',
    });
}
//获取历史数据 getDataHistResp2
export function getHistoryDataHttpReq(data) {
    return axiosReq({
        url: `${twinPrefix}/getDataHistResp2`,
        method: 'post',
        data,
        // isParams: true,
    });
}
/**
 * tbox
 */

//下载TBox日志文件
export function tboxDataDownloadHttpReq(logName) {
    return axiosReq({
        url: `${tboxPrefix}/tboxDataDownload?fileName=${logName}`,
        method: 'get',
        timeout: 18000000,
        responseType: 'blob'
    });
}
//上传TBox日志文件（发起上传日志通知）
export function downloadLogHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/api/remote-service/downloadLog`,
        method: 'post',
        data
    });
}
//通知can报文上传
export function canDataUploadElectricHttpReq(data) {
    return axiosReq({
        url: `${tboxPrefix}/canDataUpload`,
        method: 'post',
        data,
        // isParams: true,
    });
}
//获取can报文
export function canData0x8f45HttpReq(data) {
    return axiosReq({
        url: `${tboxPrefix}/can-data-0x8F45`,
        method: 'post',
        data,
        // isParams: true,
    });
}
//电动化报文下载
export function canDataDownloadElectricHttpReq(id) {
    return axiosReq({
        url: `${tboxPrefix}/canDataDownload?ids=${id}`,
        method: 'get',
        timeout: 18000000,
        responseType: 'blob'
    });
}
//保存行驶记录仪信息

export function saveTravelRecorderHttpReq(data) {
    return axiosReq({
        url: `${travelPrefix}/saveTravelRecorder`,
        method: 'post',
        data,
    });
}
//查询车架号信息
export function selectVinListHttpReq(vin) {
    return axiosReq({
        url: `${travelPrefix}/selectVinList?vin=${vin}`,
        method: 'get',
    });
}
// 查询行驶记录仪配置信息
export function selectTravelRecorderBasicInfoHttpReq(vin) {
    return axiosReq({
        url: `${travelPrefix}/selectTravelRecorderBasicInfo?vin=${vin}`,
        method: 'get',
    });
}
//tbox离线统计-》统计信息
export function tboxOfflineSummaryHttpReq() {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck-offline/count-summary`,
        method: 'get',
    });
}
//tbox离线统计-》列表
export function tboxOfflineListHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck-offline/list`,
        method: 'post',
        data,
    });
}



//TBOX管理-》添加tbox
export function addTboxHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox`,
        method: 'post',
        data,
    });
}


//TBOX管理-》编辑tbox
export function editTboxHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox`,
        method: 'put',
        data,
    });
}
//TBOX管理 =>删除tbox 
export function deleteTboxHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/${id}`,
        method: 'delete'
    });
}
// board/v1/mgmt/tbox/18
//TBOX管理 =>设置 => TBOX设置 tbox详情 
export function tboxDetailInfoHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/${id}`,
        method: 'get'
    });
}

//TBOX管理 =>设置 => TBOX设置 find-set
export function tboxFindSetHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/find-set`,
        method: 'post',
        data,
    });
}

//TBOX管理 =>设置=> TBOX设置-获取TBox目前的参数值数据
export function getFindSetIdTboxIdHttpReq(id, tBoxId) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/find-set/${id}/${tBoxId}`,
        method: 'get'
    });
}

//TBOX管理 =>设置 => TBOX设置-下发终端初始化参数设置 /v1/mgmt/tbox/set-init
export function postTboxSetInitHttpReq(data) {
    // return axios.post('board/v1/mgmt/tbox/set-init', params);
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/set-init`,
        method: 'post',
        data,
    });
}

 // TBOX管理 =>设置 =>TBOX设置-TBOX查询通用应答结果 GET /v1/
 export function getComAckHttpReq(id) {
    // return axios.get(`board/v1/mgmt/tbox/command-ack/${id}`);
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/command-ack/${id}`,
        method: 'get'
    });
}
//TBOX管理 =>设置  TBOX设置-下发终端升级设置 POST/v1/mgmt/tbox/set-update
export function  postUpdateTboxSetHttpReq(data) {
    // return axios.post('board/v1/mgmt/tbox/set-update', params);
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/set-update`,
        method: 'post',
        data,
    });
}

 //TBOX管理 =>设置   TBOX设置-下发设置TBOX参数
 export function  postTboxSetHttpReq(data) {
    // return axios.post('board/v1/mgmt/tbox/set', _.merge({}, params, query));
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/set`,
        method: 'post',
        data,
    });
}
 //TBOX管理 =>设置   TBOX设置-获取TBox参数设置状态
 export function   getTboxSetByIdHttpReq(id) {
    // return axios.get(`board/v1/mgmt/tbox/set/${id}`);
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox/set/${id}`,
        method: 'get'
    });
}
//TBOX型号-》添加tbox型号
export function addTboxModelHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox-model`,
        method: 'post',
        data,
    });
}


//TBOX型号-》编辑tbox型号
export function editModelTboxHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox-model`,
        method: 'put',
        data,
    });
}
//TBOX型号 =>删除tbox型号
export function deleteTboxModelHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/tbox-model/${id}`,
        method: 'delete'
    });
}

//glonass-》添加glonass
export function addGlonassHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/glonass`,
        method: 'post',
        data,
    });
}


//glonass-》编辑glonass
export function editGlonassHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/glonass`,
        method: 'put',
        data,
    });
}
//glonass =>删除glonass  
export function deleteGlonassHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/glonass/${id}`,
        method: 'delete'
    });
}

export function distributeLicenseArrayHttpReq(vinList){
    const data={
        vins:vinList
    }
    return axiosReq({
        url: `${baseApi}/board/v1/adasis/getLicenseAndIssue`,
        method: 'post',
        data:vinList,
    });
  }
 //零部件孪生 =>蓄电池=》当前告警 统计
 export function   currentAlarmCountHttpReq() {
    return axiosReq({
        url: `${baseApi}/board/v1/battery-management/mgmt/current-alarm-count`,
        method: 'get'
    });
}

//零部件孪生 =>蓄电池=》 统计分析
export function   alarmStatisticsHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/battery-management/mgmt/alarm-statistics`,
        method: 'get',
        data,
        isParams: true,
    });
}

//零部件孪生 =>蓄电池=》蓄电池健康度分析 
export function   batteryHealthAnalysisHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/newc-platform/v1/portal/web/batteryHealthAnalysis`,
        method: 'get',
        data,
        isParams: true,
    });
}

//零部件孪生 =>蓄电池=》蓄电池健康度分析 电池更换记录
export function   batteryChangeRecordHttpReq(vin) {
    return axiosReq({
        url: `${baseApi}/board/v1/battery-management/mgmt/batteryChangeRecord?vin=${vin}`,
        method: 'get'
    });
}


//零部件孪生 =>Tbox=》高密采集配置  保存
export function saveHighDensityCollectionHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/high/collection`,
        method: 'post',
        data,
    });
}

//零部件孪生 =>Tbox=》高密采集配置  保存
export function getHighDensityCollectionDataHttpReq() {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/high/collection`,
        method: 'get'
    });
}


